<template>
  <div
    class="plan-detail"
    v-loading="checkOutLoading">
    <template v-if="!payEnd">
      <div
        class="header"
        v-if="iframeData && iframeData.action === 'manage'">
        <div
          class="title"
          @click="goBack">
          <span class="el-icon-arrow-left"></span>
          <!-- <span v-if="nodeType == 'node'">Nodes Subscriptions</span>
          <span v-else>Cloud Subscriptions</span> -->
          <span>Manage Subscriptions</span>
        </div>
      </div>
      <div
        class="plan-con"
        :style="{background: background}">
        <div class="title-wrap">
          <div class="title">{{ plan.planDisplayName }}</div>
          <div>
            <el-popover
              placement="right-end"
              title=""
              popper-class="plan-popover"
              width="80"
              trigger="click"
            >
              <div
                class="reselect"
                @click="reselectPlan">{{ $t('mediahub.reselect') }}</div>
              <div
                class="reselect"
                @click="handleCancelSub">{{ $t('mediahub.deactivate') }}</div>
              <svg
                slot="reference"
                class="plan-popover-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect
                  opacity="0.01"
                  width="16"
                  height="16"
                  fill="black"/>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.48854 2.43801C6.98633 2.65622 6.66285 3.15312 6.66654 3.70068C6.66608 4.06086 6.80625 4.40698 7.05721 4.66534C7.30721 4.92134 7.64654 5.06468 7.99987 5.06468C8.54418 5.06139 9.03185 4.72758 9.23187 4.22134C9.43787 3.71068 9.32387 3.12334 8.94187 2.73268C8.565 2.34333 7.9873 2.2262 7.48854 2.43801ZM6.66654 8.00134C6.66285 7.45379 6.98633 6.95689 7.48854 6.73868C7.98744 6.52703 8.56515 6.64443 8.94187 7.03401C9.32387 7.42468 9.43787 8.01201 9.23187 8.52268C9.03185 9.02891 8.54418 9.36273 7.99987 9.36601C7.26387 9.36601 6.66654 8.75534 6.66654 8.00134ZM6.66654 12.3027C6.66258 11.7549 6.98611 11.2577 7.48854 11.0393C7.98744 10.8277 8.56515 10.9451 8.94187 11.3347C9.32387 11.7253 9.43787 12.3127 9.23187 12.8233C9.03185 13.3296 8.54418 13.6634 7.99987 13.6667C7.64654 13.6667 7.30721 13.5233 7.05721 13.2673C6.80625 13.009 6.66608 12.6629 6.66654 12.3027Z"
                  fill="white"/>
              </svg>
            </el-popover>
          </div>
        </div>
        <div
          class="manage-pay"
          @click="payMent">
          <div>Manage Payment</div>
          <div class="icon"><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <div class="add-wrap">
        <!-- <div class="add-title">
          <span>Hours added</span>
          <span class="valid">Hours are valid for up to {{validDate}} months</span>
        </div> -->
        <div class="title-input">
          <!-- <el-input v-model="inputAddHours" type="number" @input="handleInput" placeholder="Please input number no more than 4320"></el-input> -->
          <div
            class="charge-wrap"
            v-for="i in plan.chargeItems"
            :key="i.addonId">
            <div class="left-wrap">
              <p>{{ i.addonName }}</p>
              <!-- <p class="info">$1,050 /per 4 CPU Core</p> -->
              <p class="price-info">{{ i.displayPrice }}</p>
            </div>
            <div class="right-wrap">
              <el-input
                v-if="i.addonId == 'mh_destlow_number'"
                v-model="destlowNumber"
                type="number"
                @input="handleInput($event, i.addonId)"
                placeholder="">
              </el-input>
              <el-input
                v-if="i.addonId == 'mh_desthigh_number'"
                v-model="desthighNumber"
                type="number"
                @input="handleInput($event, i.addonId)"
                placeholder="">
              </el-input>
              <el-input
                v-if="i.addonId == 'mh_format_number'"
                v-model="formatNumber"
                type="number"
                @input="handleInput($event, i.addonId)"
                placeholder="">
              </el-input>
              <el-input
                v-if="i.addonId == 'mh_source_number'"
                v-model="inputNumber"
                type="number"
                @input="handleInput($event, i.addonId)"
                placeholder="">
              </el-input>
              <el-input
                v-if="i.addonId == 'mh_plan_core_number'"
                v-model="coreNumber"
                type="number"
                @input="handleInput($event, i.addonId)"
                placeholder="">
              </el-input>
              <span
                class="type"
                v-if="plan.classification === 2">x 4</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pay-footer">
        <div class="price">${{ this.addPlanPrice }}</div>
        <div class="confirm">
          <el-button
            @click="handleCheckOut"
            :disabled="checkDisable">{{ $t('mediahub.confirm') }}</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <img
        class="all-right"
        src="@/assets/svg/allright.svg"
        alt="">
      <div class="pay-start">PAYMENT COMPLETE</div>
      <div class="pay-info">
        Thank you, your payment has been successful.
        You can start use it now.
      </div>
      <div class="trial-footer">
        <div
          class="close"
          @click="handleCloseIframe">
          Close
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { queryPrice, handleNewSub, handlecustomerPortal, paymentMethodInfoByIntentId } from '@/common/checkuser.js'
import Helper from '@/common/helper.js'
import { Message } from 'element-ui'
export default {
  props: {
    plan: Object,
    nodeType: String,
    chooseFrom: String
  },
  inject: ['emailid', 'loadData', 'paySuccess', 'AddonsInfo', 'PlansInfo', 'Cancel'],
  data () {
    return {
      inputAddHours: null,
      lastInputHours: null,
      addPlanPrice: 0,
      addPlanQuantity: 0,
      HandleQueryPrice: null,
      checkOutLoading: false,
      payEnd: false,
      inputNumber: 0,
      formatNumber: 0,
      destlowNumber: 0,
      desthighNumber: 0,
      coreNumber: 0,
      initNumber: {
        inputNumber: 0,
        formatNumber: 0,
        destlowNumber: 0,
        desthighNumber: 0,
        coreNumber: 0
      }
    }
  },
  created () {
    this.HandleQueryPrice = Helper.debounce(this.handleQueryPrice)
    // this.handleChargeItems()
  },
  mounted () {
    this.$emit('titlechange', '')
  },
  methods: {
    // 返回manahe subs
    goBack () {
      this.$emit('reselectPlan', 'manageSubs')
    },
    getAddonKey (addonId) {
      return this.AddonsInfo[addonId]?.key
    },
    handleChargeItems () {
      this.plan.chargeItems.sort((a, b) => {
        if (a.addonId.includes('mh_source_')) return -1
        if (b.addonId.includes('mh_source_')) return 1
        if (a.addonId.includes('mh_format_')) return -1
        if (b.addonId.includes('mh_format_')) return 1
        if (a.addonId.includes('mh_destlow_')) return -1
        if (b.addonId.includes('mh_destlow_')) return 1
      })
      let initNumber = {}
      if (this.iframeData && this.iframeData.initNumber) {
        initNumber = this.iframeData.initNumber
      }

      this.plan.chargeItems.forEach(i => {
        const key = this.getAddonKey(i.addonId)
        let num = 1
        if (i.addonId == 'mh_plan_core_number') {
          num = 4
        }
        this[key] = initNumber[key] || i.quantity / num
        this.initNumber[key] = initNumber[key] || i.quantity / num
        const addon = this.AddonsInfo[i.addonId]
        i.displayName = addon.displayName
        i.displayPrice = this.PlansInfo[this.plan.planId][addon.priceKey]
      })
      this.HandleQueryPrice()
    },
    // 关闭弹窗
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    // 重新选择plan
    reselectPlan () {
      this.$emit('reselectPlan', 'choose')
    },
    // 输入时间
    handleInput (value, addonId) {
      if (!value) return this.HandleQueryPrice()
      const input = Number(value)
      const key = this.getAddonKey(addonId)
      if (input < this.initNumber[key]) {
        this[key] = this.initNumber[key]
      } else if (!Number.isInteger(input)) {
        this[key] = Math.floor(input)
      } else if (input < 0) {
        this[key] = 0
      }
      this.HandleQueryPrice()
    },
    handleAddOn (chargeItems) {
      let Destlow = {}
      let Desthigh = {}
      let Format = {}
      let Core = {}
      let Input = {}

      chargeItems.forEach(i => {
        if (i.addonId == 'mh_source_number' || i.addonId == 'mh_source_minute') {
          Input = i
        } else if (i.addonId == 'mh_destlow_number' || i.addonId == 'mh_destlow_minute') {
          Destlow = i
        } else if (i.addonId == 'mh_desthigh_number' || i.addonId == 'mh_desthigh_minute') {
          Desthigh = i
        } else if (i.addonId == 'mh_format_number' || i.addonId == 'mh_format_minute') {
          Format = i
        } else if (i.addonId == 'mh_plan_core_number') {
          Core = i
        }
      })

      return { Destlow, Desthigh, Format, Core, Input }
    },
    // 查询价格
    handleQueryPrice () {
      const planchargeItems = this.plan.chargeItems
      const { Destlow, Desthigh, Format, Core, Input } = this.handleAddOn(planchargeItems)
      let chargeItems = {}
      if (this.plan.classification == 2) {
        // 如果是空对象 return false
        if (Object.keys(Core).length == 0) return false
        chargeItems = {
          [Core.addonId]: Number(this.coreNumber) * 4
        }
      } else {
        // 如果全是空对象 return false
        if (Object.keys(Destlow).length == 0 && Object.keys(Desthigh).length == 0 && Object.keys(Format).length == 0 && Object.keys(Input).length == 0) return false
        chargeItems = {
          [Destlow.addonId]: Number(this.destlowNumber),
          [Desthigh.addonId]: Number(this.desthighNumber),
          [Format.addonId]: Number(this.formatNumber),
          [Input.addonId]: Number(this.inputNumber)
        }
      }
      let params = {
        customerId: this.emailid,
        product: this.product,
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems)
      }

      queryPrice(params).then(({ data }) => {
        if (data.previewCustomSubscription) {
          this.addPlanPrice = data.previewCustomSubscription.price / 100
          this.addPlanQuantity = data.previewCustomSubscription.quantity
        }
      })
    },
    // 点击 buy
    handleCheckOut () {
      this.checkOutLoading = true
      const planchargeItems = this.plan.chargeItems
      const { Destlow, Desthigh, Format, Core, Input } = this.handleAddOn(planchargeItems)
      let chargeItems = {}
      if (this.plan.classification == 2) {
        chargeItems = {
          [Core.addonId]: Number(this.coreNumber) * 4
        }
      } else {
        chargeItems = {
          [Destlow.addonId]: Number(this.destlowNumber),
          [Desthigh.addonId]: Number(this.desthighNumber),
          [Format.addonId]: Number(this.formatNumber),
          [Input.addonId]: Number(this.inputNumber)
        }
      }
      const params = {
        customerId: this.emailid,
        product: this.product,
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems),
        description: `${this.plan.planName} ${this.emailid} checkoutSubscription`
      }
      handleNewSub(params, this).then((res) => {
        this.checkOutLoading = false
        if (res.checkoutSubscription && res.checkoutSubscription.paymentIntentId) {
          this.paymentInfo(res.checkoutSubscription.paymentIntentId)
        } else if (res.checkoutSubscription && res.checkoutSubscription.status == 'POS-PAY') {
          this.paySuccess({
            type: 'POS-PAY',
            value: 'manage'
          })
        } else if (res.checkoutSubscription && res.checkoutSubscription.status == 'PAID') {
          const params = {
            type: 'success',
            from: 'billing',
            data: {}
          }
          window.parent.postMessage(params, '*')
          this.handleCloseIframe()
        } else {
          this.payEnd = true
        }
        // this.loadData()
      }).catch(err => {
        this.checkOutLoading = false
        if (err.type != 'NO-CARD') {
          Message.error({
            message: err.info,
            duration: 5000
          })
        }
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    paymentInfo (paymentIntentId) {
      paymentMethodInfoByIntentId({ paymentIntentId }).then(res => {
        console.log(res)
        if (res.data.paymentMethodInfoByIntentId) {
          const paymentMethodInfoByIntentId = res.data.paymentMethodInfoByIntentId
          const info = {
            'PAYMENT TYPE': paymentMethodInfoByIntentId.card?.brand || paymentMethodInfoByIntentId.type,
            'PAYMENT DATE': Helper.timestampToDate(new Date().getTime(), 'MM/DD/YYYY')
          }
          if (paymentMethodInfoByIntentId.card) {
            info.COUNTRY = paymentMethodInfoByIntentId.card.country
            info['PAYMENT METHOD'] = '**** **** ****' + paymentMethodInfoByIntentId.card.last4
          }
          this.paySuccess(info)
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    },
    // 打开 管理卡的窗口
    payMent () {
      const params = {
        customerId: this.emailid,
        product: this.product
      }
      handlecustomerPortal(params)
    },
    // cancel sub
    handleCancelSub () {
      this.Cancel(this.plan.planId)
    }
  },
  computed: {
    checkDisable () {
      if (this.plan.classification == 2) {
        return Number(this.coreNumber) < this.initNumber.coreNumber
      } else {
        const currentTotal = Number(this.formatNumber) + Number(this.destlowNumber) + Number(this.desthighNumber)
        const intiTotal = this.initNumber.formatNumber + this.initNumber.destlowNumber + this.initNumber.desthighNumber
        return currentTotal < intiTotal
      }
    },
    planDisplayName () {
      if (this.plan.planId.includes('_monthly')) {
        return 'Monthly'
      } else if (this.plan.planId.includes('_1y')) {
        return 'Yearly'
      } else if (this.plan.planId.includes('_ppu')) {
        return 'Pay per Use'
      } else {
        return ''
      }
    },
    iframeData () {
      return this.$store.state.iframeData
    },
    product () {
      return this.$store.state.product
    },
    background () {
      if (!this.plan.style) return ''
      return this.plan.style.background
    }
  },
  filters: {
    transDateAndTime (value, type) {
      value = Number(value)
      if (!value || value >= 9999999999999) return '---'
      let oDate = new Date(value)
      let oYear = oDate.getFullYear()
      let oMonth = oDate.getMonth() + 1
      let oDay = oDate.getDate()
      let oHour = oDate.getHours()
      let oMin = oDate.getMinutes()
      let oSen = oDate.getSeconds()
      let oMil = oDate.getMilliseconds()
      oHour = oHour <= 9 ? '0' + oHour : oHour
      oMin = oMin <= 9 ? '0' + oMin : oMin
      oSen = oSen <= 9 ? '0' + oSen : oSen
      oMil = oMil <= 99 ? (oMil = oMil <= 9 ? '00' + oMil : '0' + oMil) : oMil
      let oTime = ''
      if (type == 1) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = oMonth + '-' + oDay + ' ' + oHour + ':' + oMin
      } else if (type == 2) {
        oTime = oHour + ':' + oMin + ':' + oSen + ':' + oMil
      } else if (type == 3) {
        oTime = oYear + '/' + oMonth + '/' + oDay
      } else if (type == 4) {
        oTime = oYear + '-' + oMonth + '-' + oDay + ' ' + oHour + ':' + oMin + ':' + oSen
      } else if (type == 5) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = '' + oYear + oMonth + oDay + oHour + oMin + oSen + oMil
      } else if (type == 6) {
        oTime = oHour + ':' + oMin + ':' + oSen
      } else {
        oTime = oYear + '/' + oMonth + '/' + oDay + ' ' + oHour + ':' + oMin
      }
      return oTime
    }
  }
}
</script>

<style lang="less" scoped>
  .plan-detail {
    width: 408px;
    position: relative;
    min-height: 490px;
    .header {
      position: absolute;
      width: 80%;
      top: -60px;

      .title {
        line-height: 24px;
        font-weight: 700;
        font-size: 18px;
        // color: #303133;
        cursor: pointer;
      }
      .el-icon-arrow-left {
        font-weight: 900;
      }
    }
    .plan-con {
      background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      .title-wrap {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .plan-popover-icon {
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
      .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 36px;
        color: #444444;
      }
      .reselect {
        color: #ffffff;
        margin-top: 10px;
        font-size: 14px;
        border: 1px solid;
        padding: 5px 8px;
        border-radius: 8px;
        cursor: pointer;
      }
      .expiration {
        text-align: left;
        margin: 40px 0 0 20px;
        color: #EC5050;
      }
      .manage-pay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        // width: 100%;
        display: flex;
        height: 42px;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        color: #ffffff;
        cursor: pointer;
      }
      .choose {
        padding: 0 30px;
        word-break: break-word;
        text-align: left;
        font-size: 16px;
        color: #EC5050;
      }
    }

    .time-info {
      // margin: ;
      .remain {
        margin: 20px 0 10px;
        font-size: 20px;
        line-height: 23px;
        color: #585B5D;
      }
      .time-change {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-right {
          font-weight: 900;
          font-size: 18px;
          color: var(--dialog-arrow-color);
          margin: 0 15px;
        }
        .time-format {
          font-size: 16px;
          line-height: 19px;
          color: var(--dialog-text-color);
        }
        .new-time {
          color: #5DC045;
        }
      }
    }

    ::v-deep .title-input {
      .el-input__inner {
        width: 90px;
      }
      input::-webkit-inner-spin-button {
        // opacity: 1;
      }
    }
    .add-wrap {
      text-align: left;
      margin-top: 20px;
      .add-title {
        font-weight: 500;
        line-height: 20px;
        color: var(--dialog-text-color);
        .valid {
          font-size: 12px;
          line-height: 14px;
          color: var(--dialog-text-info-color);
          margin-left: 15px;
        }
      }
      .charge-wrap {
        margin: 10px 0;
        display: flex;
        color: #979DA3;
        font-size: 14px;
        .left-wrap {
          min-width: 190px;
          color: #979DA3;
          .price-info {
            font-size: 12px;
            color: #666666;
          }
        }
        .right-wrap {
          .el-input {
            width: auto;
          }
          .type {
            margin-left: 5px;
          }
        }
        .info {
          color: var(--dialog-text-info-color);
          font-size: 12px;
        }
      }
    }

    .pay-footer {
      display: flex;
      padding: 0 20px;
      position: absolute;
      bottom: 0;
      width: calc(100% - 40px);
      justify-content: space-between;
      border-top: 2px solid var(--dialog-border-color);
      padding-top: 20px;
      .confirm {
        .el-button {
          // width: 80px;
          // height: 32px;
          border: none;
          background: #33AB4F;
          color: #FFFFFF;
        }
        .el-button.is-disabled {
          background: #8BC194;
          color: #F0F0F0;
        }
      }
      .price {
        color: #33AB4F;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }

</style>
<style lang="less">
  .el-message-box__wrapper {
    .el-message-box {
      background-color: #191a1d !important;
      border: none;
      width: fit-content;
      min-width: 420px;
      .el-button--default {
        background-color: transparent;
        border: none;
        color: #dbdbdb;
      }
      .el-button--primary {
        background-color: #fd5454;
        border: none;
        color: #dbdbdb;
        border-radius: 50px;
      }
      .el-message-box__title {
        color: #dbdbdb;
      }
      .el-message-box__message {
        color: #dbdbdb;
      }
      .el-message-box__headerbtn:hover {
        .el-message-box__close {
          color: #909399;
        }
      }
    }
  }
  .el-popover.el-popper.plan-popover {
    background: #444444;
    border: none;
    color: #dbdbdb;
    .popper__arrow {
      display: none;
    }
    .reselect {
      color: #ffffff;
      margin: 5px;
      font-size: 14px;
      cursor: pointer;
    }
  }
</style>
